import React, { FC } from 'react'
import { Region } from '@moonpig/web-core-types'

import { DefaultLayout } from './components/DefaultLayout'
import { CheckoutLayout } from './components/CheckoutLayout'
import { AuthLayout } from './components/AuthLayout'
import { AttachLayout } from './components/AttachLayout'

type LayoutProps = React.ComponentProps<typeof DefaultLayout>

type FooterProps = LayoutProps['footer']

type NavItems = LayoutProps['navItems']

type HideSearchBarProps = LayoutProps['hideSearchBar']

type LayoutInitialProps =
  | {
      type: 'default'
      navItems: NavItems
      footerItems: FooterProps
      shouldHideFooter?: boolean
      hideSearchBar?: HideSearchBarProps
      hideGoogleOneTap?: boolean
      isHeaderSignInExperimentEnabled: boolean
      isConciergeSearchExperimentEnabled: boolean
      region: Region
      searchDepartment?: {
        name: string
        title: string
      }
      searchTerm?: string
      headerLogoIconUrl?: string
      nonStickyHeader?: boolean
    }
  | {
      type: 'checkout'
      region: Region
      headerLogoIconUrl?: string
    }
  | {
      type: 'auth'
      region: Region
      headerLogoIconUrl?: string
    }
  | {
      type: 'attach'
    }
  | {
      type: 'none'
    }

export const Layout: FC<
  React.PropsWithChildren<LayoutInitialProps>
> = props => {
  switch (props.type) {
    case 'default':
      return (
        <DefaultLayout
          navItems={props.navItems}
          headerLogoIconUrl={props.headerLogoIconUrl}
          footer={props.footerItems}
          searchDepartment={props.searchDepartment}
          searchTerm={props.searchTerm}
          region={props.region}
          shouldHideFooter={props.shouldHideFooter}
          hideSearchBar={props.hideSearchBar}
          shouldHideGoogleOneTap={props.hideGoogleOneTap}
          nonStickyHeader={props.nonStickyHeader}
          isHeaderSignInExperimentEnabled={
            props.isHeaderSignInExperimentEnabled
          }
          isConciergeSearchExperimentEnabled={
            props.isConciergeSearchExperimentEnabled
          }
        >
          {props.children}
        </DefaultLayout>
      )
    case 'checkout':
      return (
        <CheckoutLayout
          region={props.region}
          headerLogoIconUrl={props.headerLogoIconUrl}
        >
          {props.children}
        </CheckoutLayout>
      )
    case 'auth':
      return (
        <AuthLayout
          region={props.region}
          headerLogoIconUrl={props.headerLogoIconUrl}
        >
          {props.children}
        </AuthLayout>
      )
    case 'attach':
      return <AttachLayout>{props.children}</AttachLayout>
    default:
      return <>{props.children}</>
  }
}
